// extracted by mini-css-extract-plugin
module.exports = {"error":"_67b4b47","toggleLabel":"_12650cf"};